import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { modal } from '../../core/utilities/modal'

import NavLink from '../Routes/NavLink'
import PropertiesSelect from '../../components/Properties/PropertiesSelect';
import { reportsHandler } from '../../helpers/Reports/ReportsHandler'

export default class ReportsTableGenerator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reportData: null,
            reportColumns: null,
            reportType: 'property_leases_ending_60_days',
            lastRun: null,
            crossRefData: null,
            startDate: moment(moment().subtract(30, 'day').format("YYYY-MM-DD")),
            endDate: moment(moment().format("YYYY-MM-DD")),
            disabledRange: true,
            selectedPropertyId: 0
        };

    }

    componentDidMount() {
        var self = this;
        jQuery('.daterange').daterangepicker({
            opens: 'center',
            "startDate": self.state.startDate,
            "endDate": self.state.endDate,
            "showDropdowns": true,
            "drops": "down",
            "minYear": Number(moment().format("YYYY")) - 3,
            "maxYear": Number(moment().format("YYYY")),
            "locale": {
                "format": 'MMM Do, YYYY'
            }
        },  function(start, end) {
            self.onDateRangePick(start, end)
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.reportType == 'property_leases_ending_60_days' || nextState.reportType == 'property_delinquent_tenants' || nextState.reportType == 'owner_management_fees' || nextState.reportType == 'tenants_paid_this_month' || nextState.reportType == 'tenants_waiting_month_payment') {
            nextState.disabledRange = true;
        } else {
            nextState.disabledRange = false;
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatMoney(cell, row) {
        return '$' + cell;
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    runReport() {
        var self = this;
        modal.showInfo("Generating report...", "success", "top", "center");
        reportsHandler.getReport(this.state.reportType, this.state.startDate.format("YYYY-MM-DD"), this.state.endDate.format("YYYY-MM-DD"), this.state.selectedPropertyId, function(response) {
            self.setState({
                reportData: response.data,
                reportColumns: response.columns,
                lastRun: response.last_run
            });
        });
    }

    reportTypeChange(e) {
        this.setState({
            reportType: e.target.value,
            reportData: null,
            reportColumns: null,
            lastRun: null
        });
    }

    exportData(e) {
        modal.showInfo("Your download will begin shortly.", "success", "top", "center");
        reportsHandler.exportReport(this.state.reportType, this.state.startDate.format("YYYY-MM-DD"), this.state.endDate.format("YYYY-MM-DD"), this.state.selectedPropertyId, function(response) {
        });
    }

    formatMoney(money) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return formatter.format(money);
    }

    formatDate(cell, row) {
        if (cell == null) {
            return 'Not Set';
        }

        return moment.utc(cell).local().format('D MMM YYYY');
    }

    formatLeaseLink(cell, row) {
        return (
            <NavLink to={"/lease/" + row.leaseId}>{cell}</NavLink>
        )
    }

    formatTenantLink(cell, row) {
        if (row.tenantId == null) {
            return cell;
        }

        return (
            <NavLink to={"/tenant/" + row.tenantId}>{cell}</NavLink>
        )
    }

    formatPropertyLink(cell, row) {
        if (row.propertyId == null) {
            return cell;
        }

        return (
            <NavLink to={"/properties/" + row.propertyId}>{cell}</NavLink>
        )
    }

    formatOwnerLink(cell, row) {
        if (row.ownerId == null) {
            return cell;
        }

        return (
            <NavLink to={"/owner/" + row.ownerId}>{cell}</NavLink>
        )
    }

    onDateRangePick(start, end) {
        this.setState({
            startDate: start,
            endDate: end,
        });
        jQuery('#daterange').data('daterangepicker').setStartDate(moment(start));
        jQuery('#daterange').data('daterangepicker').setEndDate(moment(end));
    }

    handleselectedPropertyIdChange(e) {
        this.setState({
            selectedPropertyId: e.target.value
        });
    }

    render(){
        const reportData         = this.state.reportData;;
        const reportColumns      = this.state.reportColumns;
        const reportType         = this.state.reportType;
        const lastRun            = this.state.lastRun;
        const startDate          = this.state.startDate.format("MMM Do, YYYY");
        const endDate            = this.state.endDate.format("MMM Do, YYYY");
        const disabled           = this.state.disabledRange;
        const selectedPropertyId = this.state.selectedPropertyId;

        return (
            <div class="card">
                <div class="header">
                    <h4 class="title">Property, Tenant, & Owner Reports</h4>
                    <p class="category"></p>
                </div>
                <div class="content">
                    <div class="row">
                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label for="phone">Report Type</label>
                                <select class="form-control" value={reportType} onChange={this.reportTypeChange.bind(this)}>
                                    {/* <option value='owner_profit_loss'>Owner - month profit & loss</option>
                                <option value='owner_month_rent_paid'>Owner - month rent paid</option>
                                <option value='owner_management_fees_collected'>Owner - month management fees collected</option> */}
                                    <option value='owner_management_fees'>Owner - management fees</option>
                                    <option value='property_profit_loss'>Property - profit & loss per property</option>
                                    <option value='property_collected_rent_per_property'>Property - collected rent per property</option>
                                    <option value='property_leases_ending_60_days'>Property - leases ending in 60 days</option>
                                    <option value='tenants_paid_this_month'>Tenants - tenants who paid this month</option>
                                    <option value='property_delinquent_tenants'>Tenants - delinquent tenants</option>
                                    <option value='tenants_waiting_month_payment'>Tenants - tenants who have not paid current month</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Filter report based on date range</label>
                                <input type="button" class="form-control daterange" id="daterange" value={startDate + " - " + endDate} onChange={this.onDateRangePick.bind(this)} disabled={disabled} />
                            </div>
                        </div>
                        {reportType.includes("property") && (
                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label>Select a property</label>
                                    <PropertiesSelect columnSize={0} sortID={selectedPropertyId} title="" onChange={this.handleselectedPropertyIdChange.bind(this)} />
                                </div>
                            </div>
                        )}
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-sm-12" style={{marginTop: '50px'}}>
                        {/* { lastRun != null && (
                        <div class="stats">
                            <i class="fa fa-clock-o"></i>
                            <span> Last update </span>
                            <span>{moment.utc(lastRun).local().format('MMMM Do YYYY')}</span>
                        </div>
                        )} */}
                        {reportData != null && reportType == 'property_leases_ending_60_days' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='lease' dataFormat={this.formatLeaseLink} dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='tenant' dataFormat={this.formatTenantLink} dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='property' dataFormat={this.formatPropertyLink} dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='expires' dataFormat={this.formatDate} dataSort={ true }>{reportColumns[3]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'property_delinquent_tenants' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='lease' dataFormat={this.formatLeaseLink}  dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='tenant'dataFormat={this.formatTenantLink}  dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='last_payment' dataFormat={this.formatDate} dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='amount_owed' dataSort={ true }>{reportColumns[3]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'tenants_waiting_month_payment' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='lease' dataFormat={this.formatLeaseLink}  dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='tenant'dataFormat={this.formatTenantLink}  dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='due_at' dataFormat={this.formatDate} dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='amount_owed' dataSort={ true }>{reportColumns[3]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'tenants_paid_this_month' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='lease' dataFormat={this.formatLeaseLink}  dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='tenant'dataFormat={this.formatTenantLink}  dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='last_payment' dataFormat={this.formatDate} dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'property_collected_rent_per_property' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='property' dataFormat={this.formatPropertyLink} dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='collected' dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='amount_owed' dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'property_profit_loss' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='property' dataFormat={this.formatPropertyLink} dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='income' dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='expense' dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'owner_management_fees' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='owner' dataFormat={this.formatOwnerLink} dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='amount' dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='description' dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'owner_management_fees_collected' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='owner' dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='fees_collected' dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='last_collected' dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'owner_month_rent_paid' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='owner' dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='property' dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='units' dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='current_collected' dataSort={ true }>{reportColumns[3]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='current_owed' dataSort={ true }>{reportColumns[4]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        {reportData != null && reportType == 'owner_profit_loss' && (
                            <BootstrapTable data={reportData} version='4' striped search pagination>
                                <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='owner' dataSort={ true }>{reportColumns[0]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='property' dataSort={ true }>{reportColumns[1]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='expenses' dataSort={ true }>{reportColumns[2]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='income' dataSort={ true }>{reportColumns[3]}</TableHeaderColumn>
                                <TableHeaderColumn dataField='net_income' dataSort={ true }>{reportColumns[4]}</TableHeaderColumn>
                            </BootstrapTable>
                        )}
                        { reportData == null && (
                            <p>No results to show.</p>
                        )}
                        </div>
                </div>
                    {reportData != null && (
                        <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-warning btn-fill pull-right mr-1" autoComplete="off" onClick={this.exportData.bind(this)}>
                            Export CSV
                        </button>
                    )}
                    <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.runReport.bind(this)}>
                        Run Report
                    </button>
                    <div class="clearfix"></div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Reports/ReportsTableGenerator.jsx